import { Button, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components/macro";

/** a page outside of the auth provider for testing auth issues */
export function FlightHelloTestPage() {
  return (
    <Styles>
      <Typography className="version" variant="body1" color="inherit">
        Flight Version: {process.env.REACT_APP_VERSION}
      </Typography>
      <Link to="/">
        <Button>Continue to Flight</Button>
      </Link>
    </Styles>
  );
}
const Styles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1em;
  padding: 1em;
`;
